import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors } from "../constants/GlobalStyles";

const IconHistory = (props: IconProps) => (
  <svg
    width={props.width || "23"}
    height={props.height || "25"}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5 8.28925H12V13.2892L16.28 15.8292L17 14.6192L13.5 12.5392V8.28925ZM13 3.28925C10.6131 3.28925 8.32387 4.23746 6.63604 5.92528C4.94821 7.61311 4 9.9023 4 12.2892H1L4.96 16.3192L9 12.2892H6C6 10.4327 6.7375 8.65225 8.05025 7.3395C9.36301 6.02674 11.1435 5.28925 13 5.28925C14.8565 5.28925 16.637 6.02674 17.9497 7.3395C19.2625 8.65225 20 10.4327 20 12.2892C20 14.1458 19.2625 15.9262 17.9497 17.239C16.637 18.5517 14.8565 19.2892 13 19.2892C11.07 19.2892 9.32 18.4992 8.06 17.2292L6.64 18.6492C7.47161 19.4897 8.46234 20.156 9.55433 20.6093C10.6463 21.0626 11.8177 21.2937 13 21.2892C15.3869 21.2892 17.6761 20.341 19.364 18.6532C21.0518 16.9654 22 14.6762 22 12.2892C22 9.9023 21.0518 7.61311 19.364 5.92528C17.6761 4.23746 15.3869 3.28925 13 3.28925Z"
      fill={props.color || colors.secondaryAction.default}
    />
  </svg>
);

export default IconHistory;
